import React, { useCallback, useMemo } from 'react';
import useNRPaginatedQuery from '../../../../graphql/useNRPaginatedQuery';
import { QL_LIST_ASSET_CORRELATIONS } from '../../../../graphql/queries/assetCorrelations';
import NRCorrelationsGrid from './NRCorrelationsGrid';

const DEFAULT_PAGE_SIZE = 10;

function mapEdgesToRows(edges) {
  if (!Array.isArray(edges)) return [];
  return edges.map(({ node }) => ({
    ...node,
    id: node?.assetId,
    fileName: node?.location
  }));
}

function NRCorrelationsGridContainer({ setOpen, composedAssetId, correlationType, identifier }) {
  const listArgs = useMemo(
    () => ({
      identifier,
      correlationType,
      ...(composedAssetId ? { composedAssetId } : {}),
      cursor: { first: DEFAULT_PAGE_SIZE }
    }),
    [identifier, correlationType, composedAssetId]
  );

  const [rows, loading, fetchMore, pageInfo, , totalCount] = useNRPaginatedQuery({
    query: QL_LIST_ASSET_CORRELATIONS,
    options: {
      variables: { args: listArgs },
      context: { version: 'v3' },
      fetchPolicy: 'cache-and-network'
    },
    qlObjKey: 'listAssetCorrelations',
    transformData: mapEdgesToRows,
    defaultValue: []
  });

  const handleFetchMore = useCallback(
    cursor => {
      fetchMore({
        args: {
          identifier,
          correlationType,
          ...(composedAssetId ? { composedAssetId } : {}),
          cursor
        }
      });
    },
    [fetchMore, identifier, correlationType, composedAssetId]
  );

  return (
    <NRCorrelationsGrid
      setOpen={setOpen}
      rows={rows}
      loading={loading}
      handleFetchMore={handleFetchMore}
      pageInfo={pageInfo}
      totalCount={totalCount}
      pageSize={DEFAULT_PAGE_SIZE}
    />
  );
}

export default NRCorrelationsGridContainer;
